import { apiConfig, loginRequest } from '../auth/authConfig';
import { msalInstance } from '../auth/msalClient';
import { client } from './generated/client.gen';

client.setConfig({
  baseURL: apiConfig.baseUrl,
});

// Ensure every request through client.instance uses the correct baseURL and auth.
// setConfig only updates hey-api's internal config (used by generated SDK calls),
// but direct client.instance.get() calls use axios defaults which may not be in sync.
client.instance.interceptors.request.use((config) => {
  const cfg = client.getConfig();
  config.baseURL = cfg.baseURL;
  if (cfg.auth) {
    config.headers.Authorization = `Bearer ${cfg.auth}`;
  }
  return config;
});

// On 401 (expired token), silently refresh and retry the request once.
// This handles the race after PC wake where React Query refetches before
// the token interval has had a chance to refresh.
client.instance.interceptors.response.use(undefined, async (error) => {
  const originalRequest = error.config;
  if (
    error.response?.status === 401 &&
    originalRequest &&
    !originalRequest._retried
  ) {
    originalRequest._retried = true;
    try {
      const account = msalInstance.getActiveAccount();
      if (account) {
        const response = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account,
        });
        client.setConfig({
          baseURL: apiConfig.baseUrl,
          auth: response.accessToken,
        });
        originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;
        return client.instance.request(originalRequest);
      }
    } catch {
      // Silent refresh failed — let the error propagate.
      // AccessTokenProvider will redirect to login on its next attempt.
    }
  }
  return Promise.reject(error);
});
